import { makeStyles } from "tss-react/mui";

/**
 * Shared layout classes for full-page data tables (devices, files, downloads, admin lists, ...).
 * Centralizing this keeps the Paper's elevation shadow rendering identically everywhere: without
 * a shared `tableWrapper` padding, the shadow either gets clipped entirely by `overflow: hidden`
 * flush against the Paper, or renders unclipped and bottom-heavy (MUI's elevation shadow is a
 * directional drop-shadow) when there's no wrapper at all.
 */
export const useFullPageTableLayoutStyles = makeStyles()((theme) => ({
    tableLayout: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    tableWrapper: {
        position: "relative",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: theme.spacing(0.5),
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "auto",
        overscrollBehavior: "contain",
    },
    tableContainerNoScroll: {
        overflowY: "hidden",
    },
    pagination: {
        flexShrink: 0,
    },
}));
